import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiComponentsModule } from '@mwe/ui/components';

@Component({
  selector: 'lib-ikp-info-input-read-only',
  standalone: true,
  imports: [CommonModule, UiComponentsModule],
  templateUrl: './info-input-read-only.component.html',
  styleUrl: './info-input-read-only.component.scss',
})
export class InfoInputReadOnlyComponent {
  readonly label = input<string>();
  readonly value = input<string>();
  readonly id = input<string>();
  readonly minWidth = input<string>();
  readonly dataTest = input<string>();
}
